import React, { Component } from 'react';
import {Bar} from 'react-chartjs-2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { withScriptjs } from 'react-google-maps';
import GetCMenu from './getCMenu';
import Map from './Map';
import { confirmAlert } from 'react-confirm-alert';
import GetCCliente from './getCCliente';
import { v4 as uuidv4 } from 'uuid';
const MapLoader = withScriptjs(Map);

class getNewMotorizado extends Component {
  constructor(props){
    super(props);
      this.state = {
        id_sucural :0,
        lat:0,
        lng:0,
        latF:0,
        lngF:0,
        lat_T:0,
        lon_T:0,
        modulo_modal:'',
        name:'',
        id_sucursal:this.props.id_sucursal,
        id_cliente : 0 ,
        total_precio:0,
        total_final:0,
        costo_delivery:0,
        sub_modulo_modal : '',
        token_Client:'',
        msg_loading:false,
        id_forma_pago : 0,
        forma_pago :"Seleccionar Pago",
        razon_social :"CONSUMIDOR FINAL",
        ruc:"9999999999999",
        telefono:"S/N",
        direccion:"S/N",
        email:"S/N",
        id_datos_facturacion:0,
        alias:"Seleccionar Alias",
        ubicacion:'Seleccionar Ubicación',
        nombre:'',
        id_ubicacion:0,
        referencia_entrega:'',
        total_kilometros:0,
        costo_kilometro:0,
        tarifario:[]
      }

  }
  buscarTheme =()=>{
    const url= this.props.dir_url + "webapp/getDataInformacionSucursal";
    const token =  this.props.token
    const id_sucursales= this.state.id_sucursal

    var obj = { accion:'datainformacionsucursal', token,id_sucursales };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data[0])
      if(data[0].status==="ok"){
        //console.log(data[0].tarifa_json[0])
        this.setState(
          {
            lat:data[0].msg[0].lat,
            lng:data[0].msg[0].lon,
            tarifario:data[0].tarifa_json
          }
        )
      }
    })
    .catch(console.log)
  }
  getValorDelivery =()=>{

  }
  get_encerar_direccion =()=>{
    this.setState({
      latF:0,lngF:0
    },()=>{
      this.getValorDelivery()
    })
  }
  get_coordenadas =(latF,lngF,ubicacion,id_ubicacion,referencia)=>{
    this.setState({
      latF,lngF,ubicacion,id_ubicacion,referencia_entrega:referencia
    },()=>{
      this.getValorDelivery()
    })
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }
  inputChangedHandler2 = (referencia_entrega)=>{
    this.setState({
      referencia_entrega
    })
  }
  getValueKilometros =(total_kilometros,lat_T,lon_T)=>{
    let costo_delivery =0
    let BreakException = {};
    try {
        const tarifario = this.state.tarifario.filter(tarifario => (Number(total_kilometros)/1000)<Number(tarifario.kilometro))
        tarifario.forEach(cp => {
            costo_delivery=Number(cp.valor)
            throw BreakException
        })
      } catch (e) {
        if (e !== BreakException) throw e;
    }
    total_kilometros= Number(total_kilometros)/1000
    this.setState({
      total_kilometros,costo_delivery,total_final:costo_delivery,lat_T,lon_T
    })
  }
  getRegresar =()=>{
    this.setState({
      sub_modulo_modal:''
    })
  }
  get_List_Cliente =()=>{
    const url= this.props.dir_url + "webapp/getDataClient";
    const token =  this.props.token
    const token_Client =  this.state.token_Client
    var obj = { accion:'datacliente', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          id_forma_pago:data[0].msg[0].id_forma_pago,
          forma_pago:data[0].msg[0].forma_pago,
          id_datos_facturacion:data[0].msg[0].id_datos_facturacion,
          razon_social:data[0].msg[0].razon_social,
          ruc:data[0].msg[0].ruc,
          telefono:data[0].msg[0].telefono,
          direccion:data[0].msg[0].direccion,
          email:data[0].msg[0].correo_electronico,
          alias:data[0].msg[0].alias
        })
      }
    })
    .catch(console.log)
  }
  get_opcion_no =()=>{

  }
  get_go_to=(opcion)=>{
    if(opcion==='finalizar_pedido'){
      confirmAlert({
        title: 'Enviar Pedido',
        message: '¿Desea Enviar Pedido?',
        buttons: [
          {
            label: 'Sí',
            onClick: () => this.get_finalizar_pedido(0)
          },
          {
            label: 'No',
            onClick: () => this.get_opcion_no()
          }
        ]
      })
    }
  }


  get_finalizar_pedido =(id_forma_pedido)=>{
    //base12, base0, iva12, total, id_estado_pedido, uuid_pedido, uuid_cliente, tiempo_estimado,
    // lat, lon,
    //const lista_items = this.props.lista_items
    const url= this.props.dir_url + "webapp/getNewPedido";
    const token =  this.props.token
    const token_Client =  this.state.token_Client
    const id_sucursal = this.state.id_sucursal
    const total_final = this.state.total_final
    const id_forma_pago =this.state.id_forma_pago
    const id_datos_facturacion =this.state.id_datos_facturacion
    const lat = this.state.lat_T
    const lon = this.state.lon_T
    let detalle_pedido = []
    let lista_items_adicional=[]
    const costo_delivery= this.state.costo_delivery
    const direccion_entrega = this.state.ubicacion
    const referencia_entrega = this.state.referencia_entrega
    const total_kilometros = this.state.total_kilometros
    const tipo_pedido = 1
    detalle_pedido=[...detalle_pedido, {
     'cantidad': 1,
     'id_producto': 999,
      'observacion' : '',
      'nota' : '',
      'precio_neto' : 0,
      'iva': 0,
      'uuid_detalle':uuidv4()
    }]

    var obj = { accion:'nuevopedido', token, token_Client,id_sucursal,total_final,id_forma_pago,id_datos_facturacion,lat,lon,
    costo_delivery,detalle_pedido,id_forma_pedido,lista_items_adicional,direccion_entrega,referencia_entrega,tipo_pedido,total_kilometros}
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.get_new_pedido_loading()
      }
    })
    .catch(console.log)
    this.get_loading(true)
  }
  get_new_pedido_loading =()=>{
    this.get_loading(false)
    this.props.get_salir_vista_pedido()
  }
  editarCliente =()=>{
    this.setState({
      sub_modulo_modal:'cliente'
    })
  }
  getDataCliente =(id_cliente,nombre,token_Client)=>{
    //console.log(id_cliente+" "+nombre+" "+token_Client)
    this.setState({
      sub_modulo_modal:'',
      id_cliente,
      nombre,
      token_Client
    },()=>{
      this.get_List_Cliente()
    })
  }
  render(){
    const id_cliente = this.state.id_cliente
    const sub_modulo_modal = this.state.sub_modulo_modal
    let dir_sub_modulo_modal
    if(sub_modulo_modal==='cliente'){
      dir_sub_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
                            <GetCCliente  getDataCliente={this.getDataCliente} token={this.props.token} dir_url={this.props.dir_url} getRegresar={this.getRegresar} />
                            </div>
    }
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }

    const total_final = this.state.total_final
    return(
      <React.Fragment>
      <div className="cssversion_menu cssversion_colorwhite" style={{"color":"black"}}>
        <div className="cssversion_pw100 cssversion_pxh50 cssversion_colorblanco" style={{"display":"flex"}}>
          <div className="cssversion_pw10 cssversion_contentCenter" onClick={ () => this.props.get_salir_vista_pedido()}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
          </div>
          <div className="cssversion_pw90 cssversion_contentCenter" >
            <div className="cssversion_pw100 cssversion_ph20">

            </div>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_ph90" style={{"display":"flex"}}>
          <div className="cssversion_pxw250 cssversion_ph100 cssversion_inlinetable" >
          <GetCMenu
          inputChangedHandler2 ={this.inputChangedHandler2}
          referencia_entrega= {this.state.referencia_entrega}
          get_List_Cliente={this.get_List_Cliente}
          id_forma_pago ={this.state.id_forma_pago}
          forma_pago ={this.state.forma_pago}
          razon_social ={this.state.razon_social}
          ruc={this.state.ruc}
          telefono={this.state.telefono}
          direccion={this.state.direccion}
          email={this.state.email}
          id_datos_facturacion={this.state.id_datos_facturacion}
          alias={this.state.alias}
          ubicacion={this.state.ubicacion}
          nombre={this.state.nombre}
          id_ubicacion={this.state.id_ubicacion}
          lat={this.state.lat} lon={this.state.lon}
          token={this.props.token} dir_url={this.props.dir_url} token_Client={this.state.token_Client}
          id_cliente={this.state.id_cliente}
          editarCliente={this.editarCliente} costo_delivery={this.state.costo_delivery}
          total_final={this.state.total_final} total_precio={this.state.total_precio} get_coordenadas={this.get_coordenadas}
          total_kilometros={this.state.total_kilometros}
          get_encerar_direccion={this.get_encerar_direccion} />
          </div>
          <div className="cssversion_pxw400 cssversion_ph100" >
            <div className="cssversion_pw100 cssversion_pxh400" >
            {(Number(this.state.lat)!==0&&Number(this.state.latF)!==0)?
              <MapLoader
                getValueKilometros = {this.getValueKilometros}
                lat={this.state.lat} lng={this.state.lng} latF={this.state.latF} lngF={this.state.lngF}
                googleMapURL="https://maps.googleapis1.com/maps/api/js?key=AIzaSyAhGBIYFLkWPbqHVQ_kHj3nWwrkDiiFUXg"
                loadingElement={<div style={{ height: `100%` }} />}
              />
            :''}
            </div>
            <div className="cssversion_pw100" >
              {(Number(total_final)>0&&Number(id_cliente)>0)?
              <div className="">
                <button className="button-global" style={{"width":"400px"}} onClick={ () => this.get_go_to("finalizar_pedido")}>Pedir Motorizado por ${Number(total_final).toFixed(2)}</button>
              </div>
              :''}
            </div>
          </div>
        </div>
        {dir_sub_modulo_modal}
        {modal_loading}
      </div>
      </React.Fragment>
    )
  }


  componentDidMount (){
    this.buscarTheme()
  }

}
export default getNewMotorizado;
